// extracted by mini-css-extract-plugin
export default {"warningTextWrapper":"_335bc06f0e4f700f","deletedItemsFilter":"e7fb1b709a9eef39"};